/*jshint esversion: 6 */
$( document ).ready(function() {
    $('[data-request]').change(function (e) {
        var obj = $(this);
        sendRequest(obj);
    });

    $('button[data-type]').click(function(e) {
        var obj = $(this).parent().find('[data-request]');
        sendRequest(obj);
    });

    $('button[price-data-type]').click(function(e) {
        var obj = $(this).parent().find('[name]');
        sendRequest(obj);
    });

    function sendRequest(obj) {
        var $this = $(obj),
            type = $this.attr('data-type'),
            name = $this.attr('data-name'),
            value = $this.val(),
            id = $this.attr('data-id');

        if($this.is('input[type=checkbox]')) {
            value = $this.prop('checked');
        }

        $.ajax({
            method: 'POST',
            url: $('body').attr('data-base-url') + 'settings/save',
            dataType: 'json',
            data: {
                type: type,
                value: value,
                name: name,
                id: id
            }
        }).done(function (data) {
            if(data.success) {
                saveToast();
                var el = $("[data-type='"+type+"']");
                if(el.length > 0) {
                    el.attr('data-id', data.id);
                }
            }
        });
    }

    $('#coupons-table').DataTable({
        "searching": true,
        "lengthChange": false,
        "pagination": true
    });
});
